export default {
  titlePage: "ログイン",
  username: "ユーザー名",
  password: "パスワード",
  signIn: "ログイン",
};
